import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f56d678e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d678e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f56d678e')) {
      api.createRecord('f56d678e', component.options)
    } else {
      api.reload('f56d678e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f56d678e&scoped=true", function () {
      api.rerender('f56d678e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/functionModule/interfaceInfo/index.vue"
export default component.exports